(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCampaignDialogController', CrmCampaignDialogController);

    CrmCampaignDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmCampaign'];

    function CrmCampaignDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmCampaign) {
        var vm = this;

        vm.crmCampaign = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmCampaign.id !== null) {
                CrmCampaign.update(vm.crmCampaign, onSaveSuccess, onSaveError);
            } else {
                CrmCampaign.save(vm.crmCampaign, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmCampaignUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
